export const getFontUrl = (font: string): string => {
    return `${process.env.REACT_APP_ORIGIN}/fonts/${font}`;
}